import { create } from 'zustand'
import { getBoolean, getString, fetchAndActivate } from 'firebase/remote-config'
import { remoteConfig } from '@/shared/lib/firebase'

interface ConfigState {
    enableV2S: boolean
    enableStoryboardAIImageGeneration: boolean
    enableCharacterAIImageGeneration: boolean
    v2sInterestForm: string
    v2sDemoLink: string
    isInitialized: boolean
    initializeConfig: () => Promise<void>
}

export const useRemoteConfigStore = create<ConfigState>((set) => ({
    enableV2S: true,
    enableStoryboardAIImageGeneration: true,
    enableCharacterAIImageGeneration: true,
    v2sInterestForm: "",
    v2sDemoLink: "",
    isInitialized: false,
    initializeConfig: async () => {
        try {
            await fetchAndActivate(remoteConfig)
            const stringValue = getString(remoteConfig, 'v2sInterestForm')
            const demoLink = getString(remoteConfig, 'v2sDemoLink')
            set({
                enableV2S: getBoolean(remoteConfig, 'ENABLE_V2S'),
                enableStoryboardAIImageGeneration: getBoolean(remoteConfig, 'ENABLE_STORYBOARD_AI_IMAGE_GENERATION'),
                enableCharacterAIImageGeneration: getBoolean(remoteConfig, 'ENABLE_CHARACTER_AI_IMAGE_GENERATION'),
                v2sInterestForm: stringValue,
                v2sDemoLink: demoLink,
                isInitialized: true
            })
            console.log('✅ Remote Config initialized')
        } catch (error) {
            console.error('Failed to fetch remote config', error)
            set({ isInitialized: true })
        }
    }
}))
